import React from "react";

import { ReactComponent as IconClose } from "../../assets/images/ActiveLearning/icon_close.svg";
import guideline from "../../assets/images/guideline.png";
import preparation from "../../assets/images/preparation.png";
import Portal from "../../atoms/Portal";

import styles from "./ModalPreparationConfirm.module.scss";

export type Props = {
  onClose: () => void;
  openGuideline: () => void;
  openPreparation: () => void;
};

const ModalPreparationConfirm: React.FC<Props> = ({
  onClose,
  openGuideline,
  openPreparation,
}) => {
  return (
    <Portal>
      <div className={styles.modal}>
        <div className={styles.modal__backDrop} onClick={onClose} />
        <div className={styles.modal__content}>
          <IconClose className={styles.customModal__close} onClick={onClose} />
          <p className={styles.customModal__title}>
            授業準備の方法を選んでください。
          </p>
          <div className={styles.customModal__content}>
            <div className={styles.customModal__area}>
              <div className={styles.customModal__area__header}>
                <p className={styles.customModal__area__title}>指導書</p>
                <p className={styles.customModal__area__subtitle}>
                  授業内容を深く理解できる資料です。
                </p>
                <div className={styles.customModal__area__image}>
                  <img src={guideline} alt="guideline" />
                </div>
                <div className={styles.customModal__area__lesson}>
                  <div className={styles.customModal__area__lesson__label}>
                    <p>所要時間：20分</p>
                    <p>ページ数：10-17P</p>
                  </div>
                  <div className={styles.customModal__area__lesson__detail}>
                    <p>・各Lessonの目的</p>
                    <p>・授業の全体像</p>
                    <p>・指導案</p>
                    <p>・各ページの目的と詳細</p>
                    <p>・発問例</p>
                    <p>・回答例　など</p>
                  </div>
                </div>
                <div>
                  <button onClick={openGuideline}>指導書を開く</button>
                </div>
              </div>
            </div>
            <div className={styles.customModal__area}>
              <div className={styles.customModal__area__header}>
                <p className={styles.customModal__area__title}>
                  ダイジェスト資料
                </p>
                <p className={styles.customModal__area__subtitle}>
                  短時間で指導書の要点をおさえられる資料です。
                </p>
                <div className={styles.customModal__area__image}>
                  <img src={preparation} alt="preparation" />
                </div>
                <div className={styles.customModal__area__lesson}>
                  <div className={styles.customModal__area__lesson__label}>
                    <p>所要時間：5分</p>
                    <p>ページ数：2-3P</p>
                  </div>
                  <div className={styles.customModal__area__lesson__detail}>
                    <p>・このLessonの目的</p>
                    <p>・生徒の変化イメージ</p>
                    <p>・各ページの目的</p>
                    <p>・発問例　など</p>
                  </div>
                </div>
                <div>
                  <button onClick={openPreparation}>
                    ダイジェスト資料を開く
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Portal>
  );
};

export default ModalPreparationConfirm;
